import {  Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import {UserService} from "../../../services/user.service";
import {AppDataService} from "../../../services/app-data.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
import {RecipeBean} from "../../../beansts/recipe.bean"
import {ItemBean} from "../../../beansts/item.bean"
import { WalletService }  from '../../../services/wallet.services';

declare let $: any;
declare let Swal:any;
declare let solanaWeb3:any;
declare let splToken:any;

@Component({
    selector : 'edit-object-modal',
    templateUrl:'edit-object-component.html'
})
export class EditObjectComponent implements OnInit, OnDestroy{

  public page='main'
  public roomId=0;
  public npcId=0;
  public images=[];
  public room;
  public dimensionForm : FormGroup;
  public otherForm : FormGroup;
  public actionForm : FormGroup;
  public chairForm : FormGroup;


  public npcDataForm : FormGroup;
  public questionDataForm : FormGroup;
  public writDataForm : FormGroup;
  public myQuestionBuffer;

  public npcs=[]
  public recipes:Array<RecipeBean>
  public recipe:RecipeBean
  public npc;


  public collision=false;
  public categories;
  public chair=false;
  public selectedItem={
    thumbnail:'',
  name:''  };

  public actions = [{id:0,text:''},{id:1,text:'Mapa'},{id:2,text:'Link'},{id:3,text:'Embed'},{id:4,text:'Teleporte'},{id:5,text:'Avatar'},{id:6,text:'Administrar'},{id:7,text:'NPC'},{id:8,text:'Container'},{id:9,text:'Receita'},{id:10,text:'TeleportDoor'},{id:11,text:'Item_Manipulavel'},{id:12,text:'Meeting'},{id:13,text:'localConference'}];

  public rooms=[]
  public childrenRooms=[]
  public textures=[]
  public toggle=['true','false']
  public params={param:"",text:""};
  public paramValue="";
  public fileName;

  public cellSpec=null
  public npcForm=0;
  public actionValue={id:0,text:''};
  public texture;
  public category;
  public textureName;
  public imageStr
  public boss=false;
  public objectId;
  public objectroom;

  public constructor( private _router : Router,private _auth : UserService,public _appData : AppDataService,private fb : FormBuilder, private _companyService : CompanyService, private _walletService : WalletService) {
/*

    
*/
/*    if (this._appData.instagramUser){
      if (this._appData.instagramUser.uid=='T6sKpIAzwlPlYmEGgy2FuolQ2wN2'){
        this.boss=true;
      }
    }*/
    this.boss=true
    }
    
    public selectThumbnailItem(item){
      this.selectedItem=item;
      this.selectThumbnail(this.selectedItem);
    }
    public findTexture(){
      this.textures=[]
      this._companyService.getCategories().get().then(val=>{
        this.categories=val.data();
        Swal.fire({
          title: 'Selecione uma categoria para buscar imagens',
          input: 'select',
          inputOptions: this.categories,
          inputPlaceholder: 'Selecione categoria',
          showCancelButton: true,
          inputValidator: (value) => {
              if (value) {
                let ref=this._companyService.getTextures(value).get().then(val=>{
                    val.forEach((itemRef) =>{
                    // All the items under listRef.
                    let thumbnail=itemRef.data();
                    let url=thumbnail.thumbnail
                    this.textures.push(url) 
                  });
                  this.page='textures'
                 })
   
              } 
          }
        })
  
      })

      
    }
    public closeTexture(){
      this.page='textures'
    }
    public back(){
      this.page='main'
    }

    public addTexture(url){
      Swal.fire({
        title: 'Deseja adicionar textura a sala?',
        confirmButtonText: `Sim`,
        cancelButtonText: 'Não',
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.value) {
          this.page='main'
          let date=new Date();
          let name=date.getTime().toString()
          this.room.textures[name]=url
          this._companyService.updateRoom(this.room);
//          var iframe = document.getElementById('gameFrame')
  //        var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
    //      iWindow.location.reload();
  
    
        } else {
          this.page='main'
        }
      })      

    
    }




    public toggleChair(){
      this.chair=!this.chair
    }
    public deleteTexture(){
      if (this.selectedItem.name){
        delete this.room.textures[this.selectedItem.name]
        this._companyService.updateRoom(this.room)
        let idx=0
        for (let i=0;i<this.images.length;i++){
          if (this.images[i].name==this.selectedItem.name){
            idx=i;
            break;
          }
        }
        this.images.splice(idx,1)
        this.selectedItem.thumbnail=""
        this.selectedItem.name=""

      }
    }

    public chooseAction(action): void{

      
//  public actions = [{id:0,text:''},{id:1,text:'Mapa'},{id:2,text:'Link'},{id:3,text:'Embed'},{id:4,text:'Teleporte'},{id:5,text:'Avatar'},{id:6,text:'Administrar'},{id:7,text:'NPC'},{id:8,text:'Container'},{id:9,text:'Receita'}];
      this.actionValue=action;
      this.actionForm = this.fb.group({
        actionValue:"",
        actionValueX:"",
        actionValueY:"",
        actionValueMap:false

      });
      this.actionForm = this.fb.group({
        actionValue:"",
        actionValueX:0,
        actionValueY:0,
        actionValueMap:false,
        actionExitValueX:0,
        actionExitValueY:0,
        actionKey:0,
        actionName:"",

        });
      switch (action.id){
        case 1: {
          this.params={param:'roomToGo',text:'Defina a sala a ir e a posição (x,y) onde vai aparecer no mapa.'};          
          break;
        }
        case 2: {
          this.params={param:'link',text:'Defina a url para abrir'};          
          break;
        }
        case 3: {
          this.params={param:'link',text:'Defina a url do site que aparecerá no jogo'};          
          break;
        }
        case 6:{
          this.params={param:'defineRoomVideo',text:''};          
          break
        }
        case 7: {
          this.params={param:'npcId',text:'Defina o identificador da conversa a ligar'};          
          break;
        }
        case 4: {
          this.params={param:'teleport',text:'Defina a posição (x,y) onde enviar esse jogador'};          
          break;
        }

        case 5: {
          this.params={param:'objectId',text:''};          
          break;
        }
        case 9: {
          this.params={param:'recipe',text:'Escolha receita para anexar ao objeto'};          
          break;
        }
        case 10: {
          this.params={param:'teleportDoor',text:'Defina a posição (x,y) onde enviar esse jogador'};          
          break;
        }

        case 11:{
          this.params={param:'manipuleItem',text:'Defina containers'}
          break;
        }
        case 12:{
          this.params={param:'Meeting',text:'Sala de reunião'}
          break;
        }
        case 13:{
          this.params={param:'localConference',text:'Reunião local'}         
          break;
        }

        default:{
          this.params={param:'',text:''};          
          break;
        }

      }

  


    }
    public ngOnInit(): any {
      this.dimensionForm = this.fb.group({
        x : 40,
        y: 40,
        z:40,
        lx:1,
        ly:1,
        lz:1,
        dx:1,
        dy:1,
        dz:1,
        cx:0,
        cy:0,
        cw:1,
        ch:1,
        cellIndex:1,
        animate:false,
        collision:false,
        effectMute:false,
        effectAreaX:0,
        effectAreaY:0,
        effectAreaW:0,
        effectAreaH:0

      });
    this.otherForm = this.fb.group({
      action :"",
    });
    this.chairForm = this.fb.group({
        chairOrientation :"NW",
        chairName:"",
        chairOption:false
    });
    this.actionForm = this.fb.group({
      actionValue:"",
      actionValueX:"",
      actionValueY:"",
      actionValueMap:false,
      actionExitValueX:0,
      actionExitValueY:0,
      actionKey:0,
      actionName:"",

    });

    }
    public selectParam(param){
      this.paramValue=param.id;
    }
    public updateCollision(){
      this.collision=!this.collision
    }


  public dinamize(){
    let object=this._appData.object;
    object.static=false;
    //need to put it on the roomObjects.
    let objectId=object.objectId.toString();

    let before=this._appData.room.roomObjects.length;
    //need to remove from room
    let filter=this._appData.room.roomObjects.filter(v=>{
      return v.objectId != object.objectId
    })
    let after=filter.length

    if (after<before){
      //need to make fixes.
      this.sendIframeMessage({
        kind:'removeItem',
        item:object
      }) 
      this._appData.room.roomObjects=filter;
      this._companyService.updateRoom(this._appData.room);
      object.thumbnail=this._appData.room.textures[object.texture]
      object.thumbnailBig=this._appData.room.textures[object.texture]
      object.thumbnailSrc=this._appData.room.textures[object.texture]
      object.name = "objeto dinamizado"
      object.version=2
      object.dimension={x:object.dimensions.x/128,
                        y:object.dimensions.y/128,
                        z:object.dimensions.z/128
      }
      delete object.dimensions
      object.location="ground"
      object.room=this._appData.room.id.toString()
      object.owner="T6sKpIAzwlPlYmEGgy2FuolQ2wN2"
      object.recipeId="BMCJag1uDhnfxhVrSsDXrc813aQewiLeUAXtwRKoDVQm"
      object.tokenId="BMCJag1uDhnfxhVrSsDXrc813aQewiLeUAXtwRKoDVQm"
      object.roomReference=this._companyService.getFirebase().doc('roomObjects/'+this._appData.room.id+'/itens/'+objectId) 
      this._companyService.getUserContainerRef().doc(objectId).set(object)
      object.userReference=this._companyService.getFirebase().doc('user-container/'+this._appData.instagramUser.uid+'/itens/'+objectId) 
      delete object.roomReference;
    }
    this._companyService.getUserRoomItemRef(this._appData.room.id).doc(objectId).set(object);
    this._appData.object=object;
    //falta dar o update do objeto no jogo
    Swal.fire("Sucesso","Objeto dinamizado para a sala")

  }
  public reloadData(){
      this.page='main'
      if (this._appData.instagramUser){
        if (this._appData.instagramUser.uid=='T6sKpIAzwlPlYmEGgy2FuolQ2wN2'){
          this.boss=true;
        }
      }
      this._appData.tiping=true;
        this._companyService.getRooms().where('father','==',this._appData.room.id.toString()).get().then(val=>{
          this.rooms=[]
          val.forEach(doc=>{
            let r=doc.data();
            this.rooms.push({roomName:r.roomName,id:r.id,thumbnail:r.textures['background']})
          })
          if (this._appData.room.father){
            this._companyService.getRooms().doc(this._appData.room.father.toString()).get().then(val=>{
              this.rooms.push(val.data())
            });
          }
        })


      this._companyService.getAllNpcs().where('event','==',this._appData.event.id.toString()).get().then(val=>{
        this.npcs=[]
        val.forEach(doc=>{
          let r=doc.data();
          this.npcs.push(r)
        })
  
      })

      this._companyService.getRecipesRef(this._appData.event).get().then(val=>{
        this.recipes=[]
        val.forEach(doc=>{
          let recipe=new RecipeBean();
          recipe.parse(doc.data());
          this.recipes.push(recipe)
        })
  
      })

      let object=this._appData.object;
      this._appData.object.static=true;
      object.static=true;
      this.objectId=object.objectId;
      this.objectroom=object.room
//      public actions = [{id:0,text:''},{id:1,text:'Mapa'},{id:2,text:'Link'},{id:3,text:'Embed'},{id:4,text:'Teleporte'},{id:5,text:'Avatar'},{id:6,text:'Administrar'},{id:7,text:'NPC'},{id:8,text:'Container'},{id:9,text:'Receita'}];

      if (object.action){
        switch (object.action){
          case 'eventDoor': {
            this.actionValue={id:1,text:'Mapa'};
            this.params={param:'roomToGo',text:'Defina o id da sala a ir e as posições (x,y) onde vai aparecer.'};          
            this.paramValue=object.param['roomToGo'];

            let map=false;
            if (object.param['map']){
              map=object.param['map']
            }
            let key='';
            if (object.param['key']){
              key=object.param['key'];
            }
            let teleport=object.param['teleport']          
            if (teleport){
              this.actionForm = this.fb.group({
                actionValue:'',
                actionValueX:teleport.x,
                actionValueY:teleport.y,
                actionExitValueX:0,
                actionExitValueY:0,
                actionKey:key,
                actionValueMap:map,
                actionName:"",

                }); 
            }

            break;
          }
          case 'roomItem': {
            this.actionValue={id:11,text:'roomItem'};
            this.params={param:'roomToGo',text:'Defina o id da sala a ir e as posições (x,y) onde vai aparecer.'};          
            this.paramValue=object.param['room'];
            let key='';
            if (object.param['key']){
              key=object.param['key'];
            }
            let name='';
            if (object.param['name']){
              name=object.param['name'];
            }

            this.actionForm = this.fb.group({
                actionValue:'',
                actionValueX:'',
                actionValueY:'',
                actionExitValueX:0,
                actionExitValueY:0,
                actionKey:key,
                actionValueMap:'',
                actionName:name,
                }); 

            break;
          }
          case 'reload': {
            this.actionValue={id:12,text:'Meeting'};
            let key='';
            if (object.param['key']){
              key=object.param['key'];
            }
            let name='';
            if (object.param['name']){
              name=object.param['name'];
            }
            let link='';
            if (object.param['link']){
              link=object.param['link'];
            }
            this.actionForm = this.fb.group({
                actionValue:link,
                actionValueX:'',
                actionValueY:'',
                actionExitValueX:0,
                actionExitValueY:0,
                actionKey:key,
                actionValueMap:'',
                actionName:name,
            }); 
            this.paramValue=object.param['room'];
            break;
          }
          case 'localConference':{
            this.actionValue={id:12,text:'localConference'};
            let key='';
            if (object.param['key']){
              key=object.param['key'];
            }
            let name='';
            if (object.param['name']){
              name=object.param['name'];
            }
            this.actionForm = this.fb.group({
                actionValue:'',
                actionValueX:'',
                actionValueY:'',
                actionExitValueX:0,
                actionExitValueY:0,
                actionKey:key,
                actionValueMap:'',
                actionName:name,
            }); 
            break;
          }
          case 'openLink': {
            this.actionValue={id:2,text:'Link'};
            let link=''
            if (object.param){
              link=object.param['link']
            }

            this.params={param:'link',text:'Defina a url para abrir'};   
                this.actionForm = this.fb.group({
                  actionValue:link,
                  actionValueX:'0',
                  actionValueY:'0',
                  actionValueMap:false,
                  actionExitValueX:0,
                  actionExitValueY:0,
                  actionKey:0,
                  actionName:"",

                });       
            break;
          }
          case 'defineRoomVideo':{
            this.actionValue={id:6,text:'Administrar'};
            this.params={param:'defineRoomVideo',text:null};         
            let key=''
            if (object.param){
              key=object.param['key']
            }
            this.actionForm = this.fb.group({
                  actionValue:'',
                  actionValueX:'0',
                  actionValueY:'0',
                  actionName:'Administração',
                  actionValueMap:false,
                  actionExitValueX:0,
                  actionExitValueY:0,
                  actionKey:key,
    
                });       

            break 

          }
          case 'openModal': {
            this.actionValue={id:3,text:'Embed'};
            this.params={param:'link',text:'Defina a url para abrir'};   
            let link=''
            let name=''
            let key=''
            if (object.param){
              link=object.param['link']
              name=object.param['name']
              key=object.param['key']
            }
            this.actionForm = this.fb.group({
                  actionValue:link,
                  actionValueX:'0',
                  actionValueY:'0',
                  actionName:name,
                  actionValueMap:false,
                  actionExitValueX:0,
                  actionExitValueY:0,
                  actionKey:key,    
                });       

            break;
          }
          case 'teleport':{
            this.actionValue={id:4,text:'Teleporte'};
            this.actionForm = this.fb.group({
              actionValue:object.param['link'],
              actionValueX:'0',
              actionValueY:'0',
              actionValueMap:false,
              actionExitValueX:0,
              actionExitValueY:0,
              actionKey:0,
              actionName:"",
            });       
            this.params={param:'teleport',text:'Defina a posição (x,y) onde enviar esse usuario'};          
            break;

          }
          case 'container':{
            this.actionValue={id:8,text:'Container'};
            this.params={param:'objectId',text:''};          
            break;

          }
          case 'recipe': {
            this.actionValue={id:9,text:'Receita'};
            this.params={param:'recipe',text:'Escolha receita para anexar ao objeto'};          
            this.paramValue=object.param['recipe'];
            break;
          }
          case 'vendorTalk': {
            this.actionValue={id:7,text:'NPC'}
            this.params={param:'npcId',text:'Defina o identificador da conversa a ligar'};        
            this.paramValue=object.param['npcId'];
              break;
          }
          case 'npcTalk': {
            this.actionValue={id:7,text:'NPC'}
            this.params={param:'npcId',text:'Defina o identificador da conversa a ligar'};        
            this.paramValue=object.param['npcId'];
  
            break;
          }
          case 'selectAvatar':{
            this.actionValue={id:5,text:'Avatar'}
            break;
          }
          case 'teleportDoor':{
            this.actionValue={id:10,text:'Porta Teleporte'};
            this.params={param:'teleport',text:'Defina a posição (x,y) onde enviar esse usuario'};  
            


            this.actionForm = this.fb.group({
              actionValue:'',
              actionValueX: this._appData.object.param['xIn'],
              actionValueY: this._appData.object.param['yIn'],
              actionValueMap:false,
              actionExitValueX: this._appData.object.param['xOut'],
              actionExitValueY: this._appData.object.param['yOut'],
              actionKey: this._appData.object.param['key'],
              actionName:"",

            });       

            break;

          }
        }
      }
      else{
        this.actionValue={id:0,text:''}
        this.params={param:"",text:""};
      }
      if (!object.rotation){
        object.rotation={x:0,y:0,z:0}
      }

      let cellIndex=object.cellIndex; 
      if (!cellIndex) cellIndex=1;
      let animate=object.animate;
      if (!animate) animate=false;
      if (!object.sizeDistortion){
        object.sizeDistortion={x:1,y:1,z:1}
      }
      if (!object.collisionData){
        object.collisionData={x:0,y:0,width:1,height:1} 
      }
      if (!object.deltas){
        object.deltas={x:0,y:0,z:0} 
      }

      this.collision=object.collision
      this.dimensionForm=this.fb.group(       
        {
          x : object.dimensions.x,
          y: object.dimensions.y,
          z:object.dimensions.z,
          lx:object.sizeDistortion.x,
          ly:object.sizeDistortion.y,
          lz:object.sizeDistortion.z,         
          effectMute:object.effectMute ? object.effectMute : false,
          effectAreaX:object.effectAreaX ? object.effectAreaX : 0,
          effectAreaY:object.effectAreaY ? object.effectAreaY : 0,
          effectAreaW:object.effectAreaW ? object.effectAreaW : 0,
          effectAreaH:object.effectAreaH ? object.effectAreaH : 0,

          cellIndex:cellIndex,
          animate:animate,
          collision:object.collision,
          dx:object.deltas.x,
          dy:object.deltas.y,
          dz:object.deltas.z,
          cx:object.collisionData.x,
          cy:object.collisionData.y,
          cw:object.collisionData.width,
          ch:object.collisionData.height, 
        }       
        );

      if (object.kind=='sittable'){
        this.chairForm = this.fb.group({
          chairOrientation :object.orientation,
          chairName: object.name,
          chairOption:true
        });
        this.chair=true;
      }
      else{
        this.chairForm = this.fb.group({
          chairOrientation :"NW",
          chairName:"",
          chairOption:false
        });
        this.chair=false
      }
      if (object){
        this.texture=object.texture
      }

     this._companyService.getRoom(object.room).get().then(val=>{
          let room=val.data();
          this.room=room;
          this.room.id=object.room;
          this.images=[];
          for (let property in room.textures){
            if (this.texture && this.texture==property){
              this.images.push({name:property,thumbnail:room.textures[property],selected:true})
              this.selectedItem={
                name:this.texture,
                thumbnail:this.room.textures[this.texture]   
              }       
            }
            else{
              if (property!='background' && property!='fog'){
                this.images.push({name:property,thumbnail:room.textures[property],selected:false})
              }
            }
          }
          this.images.push({name:"NOVO",thumbnail:"./assets/landingstyle/choose.png",selected:false})   
      })

      

    }
    public isNumber(n){
      return !isNaN(parseFloat(n)) && !isNaN(n - 0);
   }
   public makeKey(){
    $('#editObjectModal').modal('hide')
    Swal.fire({
      title: 'Criar chave',
      text: 'Digite o nome da chave',
      input:'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      confirmButtonText: 'OK',
      showLoaderOnConfirm: true,
      preConfirm: (login) => {
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then ((result)=>{
      if (result.value){
        let object=this._appData.object;
        let date=new Date();
        let id=date.getTime()
        let key={
          action:"",
          event: this._appData.event.id.toString(),
          name:result.value,
          objectId:id,
          id:id,
          room:this._appData.room.id,
          texture:"https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/events%2F1592880902713%2Foffice%2Fkey.png?alt=media&token=eb077182-ce06-4d08-bb2a-32ea1808b159",
          thumbnail:"https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/events%2F1592880902713%2Foffice%2Fkey.png?alt=media&token=eb077182-ce06-4d08-bb2a-32ea1808b159",
          kind:'key',
          quantity:1,
          src:'',
          where:''
        } 
        this._companyService.addToContainer(key.id.toString(),key)
        this._appData.userEventContainer.push(key)
        this._appData.object=null;
        $('#containerModal').modal("show");
      }

    })
    

   }
public selectRecipe(recipe){
  this.recipe=recipe;
}
public createItemFromRecipe(recipe:RecipeBean){
  $('#editObjectModal').modal('hide')
  Swal.fire({
        title: 'Transferir Token pro usuario',
        text:'Quantos Tokens serão transferidos?',
        input: 'number',
        inputAttributes: {
        autocapitalize: 'off'
        },
        showCancelButton: true,
        confirmButtonText: 'OK',
        showLoaderOnConfirm: true,
      }).then((result) => {
          if (result.dismiss=='backdrop') {}
          else if (result.dismiss=='close') {}
          else if (result.dismiss=='cancel'){}
          else if (result.value) {
            let cost=result.value
            let item:ItemBean=recipe.toItem();
            let date=new Date();
            let milis=date.getTime();
            item.objectId=milis.toString();
            item.quantity=cost;
            item.event=this._appData.event.id.toString();
            /*
            Swal.fire({
              title: 'Transferindo',
              text: 'Aguarde enquanto a receita do item esta sendo criada',
              imageUrl: "https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/gameImages%2Ftransfer.gif?alt=media&token=67c0bdef-76b4-40e5-8fdb-65501ef94aff",
              showConfirmButton: false
            })*/
            this._companyService.addToUserContainer(this._appData.instagramUser,item.toDB());
            this._appData.userEventContainer=null;
            this._companyService.getUserContainer(true);


/*            this._walletService.makeTokenTransfer(this._appData.event.id,'event',this._appData.instagramUser.uid,'user',recipe.tokenId,item.quantity,item.toDB(),null,null,this._appData.instagramUser.uid,'user-container').subscribe(wa=>{
              Swal.close()
              if (wa.status==200){
                if (recipe.kind!='coin'){
                  let id=item.objectId.toString();
                  for (let i=1;i<cost;i++){
                    var novoId=id+i
                    item.objectId=novoId;
                    this._companyService.addToUserContainer(this._appData.instagramUser,item.toDB());
                  
                  }
                }
                this._appData.userEventContainer=null;
                this._companyService.getUserContainer();
                Swal.fire({title:this.translate.instant('SUCCESS'),text:'Transação finalizada com sucesso'}) 
              }
              else{
                Swal.fire({title:this.translate.instant('FAIL'),text:'Ocorreu um erro na criação do item'}) 
              }
            }, err=>{
              Swal.close()
              Swal.fire({title:this.translate.instant('FAIL'),text:'Ocorreu um erro na criação do item'}) 
            })*/
          }
      });
 
}
public selectThumbnail(item){
  this._companyService.getCategories().get().then(val=>{
    this.categories=val.data();
    if (item.name!="NOVO"){
      this.texture=item.name;
    }
    else{
      Swal.fire({
        title: 'Selecione categoria da imagem ou nada para criar uma nova category',
        input: 'select',
        inputOptions: this.categories,
        inputPlaceholder: 'Criar nova categoria',
        showCancelButton: true,
        inputValidator: (value) => {
              this.category=value;
              if (!this.category){
                $('#editObjectModal').modal('hide')
                Swal.fire({
                  title: 'Crie uma categoria para a  imagem',
                  input: 'text',
                  inputAttributes: {
                    autocapitalize: 'off'
                  },
                  showCancelButton: true,
                  confirmButtonText: 'Salvar',
                  showLoaderOnConfirm: true,
                  preConfirm: (login) => {
                    if (!login){
                      Swal.fire('Erro..','Selecione um nome pro arquivo')
                    }
                    else{
                      this.category=login;
                      this.categories={}
                      this.categories[login]=login;
                      this.addImageToCategory(); 
                    }
                }
              })
            }
            else {
                this.addImageToCategory();
            }
        }
      
      })
    }
  });
}
public addImageToCategory(){
      $('#editObjectModal').modal('hide')
      Swal.fire({
        title: 'Selecione o nome da imagem',
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off'
        },
        showCancelButton: true,
        confirmButtonText: 'Salvar',
        showLoaderOnConfirm: true,
        preConfirm: (login) => {
          if (!login){
            Swal.fire('Erro..','Selecione um nome pro arquivo')
          }
          else{
            this.fileName=login;
            Swal.fire({
              title: 'Se a imagem for composta, defina as linhasXcolunas, caso negativo, deixe vazio.',
              input: 'text',
              inputAttributes: {
                autocapitalize: 'off'
              },
              showCancelButton: true,
              confirmButtonText: 'Salvar',
              showLoaderOnConfirm: true,
              preConfirm: (dimensions) => {
                if (!dimensions){
                  this.cellSpec=null;
                  
                  $('#textureAdd').click();
                }
                else{
                  this.cellSpec=null;
                  let d=dimensions.split('X');
                  if (d.length!=2){
                    Swal.fire('Erro..','Lembre-se..linhasXcolunas. Voce precisa por o X. Tente de novo')
                    return
                  }
                  if (!this.isNumber(d[0])){
                    Swal.fire('Erro..','Lembre-se..linhasXcolunas. Voce precisa por um numero de linhas antes do X. Tente de novo')
                    return
                  }
                  if (!this.isNumber(d[1])){
                    Swal.fire('Erro..','Lembre-se..linhasXcolunas. Voce precisa por um numero de colunas apos o X. Tente de novo')
                    return
                  }
                  this.cellSpec=d;

                  $('#textureAdd').click();


                }     
              },
              allowOutsideClick: () => !Swal.isLoading()
            }).then((result) => {
            })

          }
        },
        allowOutsideClick: () => !Swal.isLoading()
      }).then((result) => {
      })

    

    }
    public deleteObject(){
      let room=this.room;
      let object=this._appData.object;
      let arrayOfObjects=room.roomObjects
      for (var i = 0; i < arrayOfObjects.length; i++) {
        var obj = arrayOfObjects[i];
        if (obj.objectId == object.objectId) {
            arrayOfObjects.splice(i, 1);
        }
      }
      room.roomObjects=arrayOfObjects;
      this._companyService.getRoom(object.room).set(room).then(val=>{
        this.sendIframeMessage({
          kind:'removeItem',
          item:this._appData.object
        })
        $('#editObjectModal').modal('hide');
      })

    
    }
    public makeArray(questions,txt){
      let arr=[]
      let id=0;
      let txtid=''
      questions.forEach((question)=>{
        txtid=txt+'-'+id.toString();
        if (question.questions){
          arr.push({'text':question.question,id:txtid,"children":this.makeArray(question.questions,txtid)})
        }
        else{
          arr.push({'text':question.question,id:txtid})
        }
        id++;
      })
      return arr;
/*      ,"children" : [
        {"text" :"Child node 1" },
        {"text" :"Child node 2" }
    ]}]
*/
    }

    public saveObject(){
      let x=this.dimensionForm.controls['x'].value;
      let y=this.dimensionForm.controls['y'].value;
      let z=this.dimensionForm.controls['z'].value;
      let lx=this.dimensionForm.controls['lx'].value;
      let ly=this.dimensionForm.controls['ly'].value;
      let lz=this.dimensionForm.controls['lz'].value;

      let effectMute=this.dimensionForm.controls['effectMute'].value
      let effectAreaX=Number(this.dimensionForm.controls['effectAreaX'].value)
      let effectAreaY=Number(this.dimensionForm.controls['effectAreaY'].value)
      let effectAreaW=Number(this.dimensionForm.controls['effectAreaW'].value)
      let effectAreaH=Number(this.dimensionForm.controls['effectAreaH'].value)


      let cellIndex=this.dimensionForm.controls['cellIndex'].value;
      let animation=this.dimensionForm.controls['animate'].value;


      let collision=this.dimensionForm.controls['collision'].value;
      let cx=this.dimensionForm.controls['cx'].value;
      let cy=this.dimensionForm.controls['cy'].value;
      let cw=this.dimensionForm.controls['cw'].value;
      let ch=this.dimensionForm.controls['ch'].value;

      let action=this.actionValue;


      let dx=Number(this.dimensionForm.controls['dx'].value);
      let dy=Number(this.dimensionForm.controls['dy'].value);
      let dz=Number(this.dimensionForm.controls['dz'].value);

//      public actions = [{id:0,text:''},{id:1,text:'Mapa'},{id:2,text:'Link'},{id:3,text:'Embed'},{id:4,text:'Teleporte'},{id:5,text:'Avatar'},{id:6,text:'Administrar'},{id:7,text:'NPC'},{id:8,text:'Container'},{id:9,text:'Receita'}];

      if (action){
        switch (action.id){
          case 1: {
            this.actionValue.text='eventDoor';
            let actionparam=this.params.param;
            this._appData.object.param={}
            this._appData.object.param[actionparam]=this.paramValue
            let x=this.actionForm.controls['actionValueX'].value;
            let y=this.actionForm.controls['actionValueY'].value;
            let key=this.actionForm.controls['actionKey'].value;
            let map=this.actionForm.controls['actionValueMap'].value;
            this._appData.object.param['teleport']={x:x,y:y}
            if (!key) key='';
            this._appData.object.param['key']=key;
            this._appData.object.param['map']=map;
            break;
          }
          case 2: {
            this.actionValue.text='openLink';
            let hasParam=this.actionForm.controls['actionValue'].value;
            if (hasParam){
              let actionparam=this.params.param;
              this._appData.object.param={}
              this._appData.object.param[actionparam]=hasParam
            }     
            break;
          }
          case 6:{
            this.actionValue.text='defineRoomVideo'
            let key=this.actionForm.controls['actionKey'].value
            if (!key) {key=''}
            this._appData.object.param={}
            this._appData.object.param['key']=key

            break;
          }
          case 3: {
            this.actionValue.text='openModal';
            let hasParam=this.actionForm.controls['actionValue'].value;
            let key=this.actionForm.controls['actionKey'].value
            let name=this.actionForm.controls['actionName'].value
            if (!hasParam){ hasParam=''}
            if (!key) {key=''}
            if (!name) {name=''}

            this._appData.object.param={}
            this._appData.object.param['link']=hasParam
            this._appData.object.param['key']=key
            this._appData.object.param['name']=name
            break;
          }
          case 7: {
            let npcId=this.paramValue
            let filter=this.npcs.filter((val)=>{
              return val.id==npcId
            })
            let npc=filter[0]
            if (npc.owner){
              this.actionValue.text='vendorTalk'
            }
            else{
              this.actionValue.text='npcTalk'
            }
            let actionparam=this.params.param;
            this._appData.object.param={}
            this._appData.object.param[actionparam]=this.paramValue

            this._appData.object.kind='npc'
            this._appData.object.param['name']=this.paramValue
            this._appData.object.param['avatar']='https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Fh0.png?alt=media&token=06662e87-0614-40b5-a0d2-9f454977429d'
            this._appData.object.param['profile_picture']='https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/events%2F1592880902713%2FeventNPC%2FeventNPCoffice.png?alt=media&token=9508e651-4718-490a-a1e6-e6cc8e2b5c01'

            break;
          }
          case 8:{
            this.actionValue.text='container'
            if (!this._appData.object.objectId){
              let date=new Date();
              let milis=date.getTime();
              this._appData.object.objectId=milis;
            }
            this._appData.object.param={objectId:this._appData.object.objectId }
            break;

          }
          case 9:{
            this.actionValue.text='recipe'
            let actionparam=this.params.param;
            this._appData.object.param={}
            let recipe=this.recipe;
            if (recipe){
              this._appData.object.param['recipe']=recipe['id']
              this._appData.object.param['kind']=recipe['kind'];
              this._appData.object.param['timeInSeconds']=recipe['timeInSeconds'];
              this._appData.object.param['baseQuantity']=recipe['baseQuantity'];
              this._appData.object.param['skill']=recipe['skillId']; 
            }
            break;
          }
          case 10:{
            this.actionValue.text='teleportDoor'
            let actionparam=this.params.param;
            this._appData.object.param={}
            this._appData.object.param['xIn']=this.actionForm.controls['actionValueX'].value;
            this._appData.object.param['yIn']=this.actionForm.controls['actionValueY'].value;
            this._appData.object.param['xOut']=this.actionForm.controls['actionExitValueX'].value;
            this._appData.object.param['yOut']=this.actionForm.controls['actionExitValueY'].value;
            this._appData.object.param['key']=this.actionForm.controls['actionKey'].value;

            break;
          }
          case 11: {
            this.actionValue.text='roomItem';         
            let actionparam=this.params.param;
            this._appData.object.param={}
            let key=this.actionForm.controls['actionKey'].value;
            let name=this.actionForm.controls['actionName'].value

            if (!key) key='';
            if (!name) name='';
            this._appData.object.param['key']=key;
            this._appData.object.param['name']=name;
            this._appData.object.param['room']=this.paramValue;
            break;
          }
          case 12: {
            this.actionValue.text='reload';         
            let actionparam=this.params.param;
            this._appData.object.param={}
            let key=this.actionForm.controls['actionKey'].value;
            let name=this.actionForm.controls['actionName'].value

            if (!key) key='';
            if (!name) name='';
            this._appData.object.param['key']=key;
            this._appData.object.param['name']=name;
            this._appData.object.param['link']='https://liveplanet.app.br/meeting/'+this._appData.event.id+'?room='+this.paramValue;
            this._appData.object.param['room']=this.paramValue;

            break;
          }
          case 5:{
            this.actionValue.text='selectAvatar'
            break;
          }
          case 13: {
            this.actionValue.text='localConference';         
            this._appData.object.param={}
            let key=this.actionForm.controls['actionKey'].value;
            let name=this.actionForm.controls['actionName'].value
            if (!key) key='';
            if (!name) name='';
            this._appData.object.param['key']=key;
            this._appData.object.param['name']=name;
            break;
          }
        }  
      }
      action=this.actionValue;  

      this._appData.object.dimensions={x:x,y:y,z:z}
      this._appData.object.effectMute=effectMute;
      this._appData.object.effectAreaX=effectAreaX;
      this._appData.object.effectAreaY=effectAreaY;
      this._appData.object.effectAreaW=effectAreaW;
      this._appData.object.effectAreaH=effectAreaH;

      this._appData.object.sizeDistortion={x:lx,y:ly,z:lz}
      this._appData.object.cellIndex=cellIndex
      this._appData.object.animate=animation

      this._appData.object.action=action.text;
      this._appData.object.collision=collision;
      if (this.selectedItem) {
        this._appData.object.texture=this.selectedItem.name;
      }
      let isChair=this.chairForm.controls['chairOption'].value;
      if (isChair){
        this._appData.object.kind='sittable';
        this._appData.object.name=this.chairForm.controls['chairName'].value;
        this._appData.object.orientation =this.chairForm.controls['chairOrientation'].value;
        this._appData.object.collision=false;         
        this._appData.object.deltas={x:dx?dx:0,y:dy?dy:0,z:dz?dz:0}; 

      }
      else{
        if (this._appData.object.kind!='npc'){
          delete this._appData.object.kind;
        }
        delete this._appData.object.orientation;
        if (collision){
          this._appData.object.collisionData={x:cx,y:cy,width:cw,height:ch}; 
        }
      }

      var iframe = document.getElementById('gameFrame');
      if (iframe == null) return;
      var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
      this._appData.object.static=true;

      if (!this._appData.object.objectId){
        let date=new Date();
        this._appData.object.objectId=date.getTime();
        this._companyService.updateRoomObject(this._appData.object)
        this.sendIframeMessage({
          kind:'addItem',
          item:this._appData.object
        })

      }
      else {
        this._companyService.updateRoomObject(this._appData.object)
        this.sendIframeMessage({
          kind:'updateItem',
          item:this._appData.object
        })

      }

      //this._appData.object=null;
      $('#editObjectModal').modal('hide');

    }
    public sendIframeMessage(messageKind){
      var iframe = document.getElementById('gameFrame');
      if (iframe == null) return;
      var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
      iWindow.postMessage(messageKind, "*");
    }
    public ngOnDestroy() : any {
    }
    public textureAddFileEvent(fileInput: any){
      var file = fileInput.target.files[0];
      let filename: string = this.fileName;
      let date=new Date();
      let newfile = this.fileName+'_'+date.getTime();
      $('#uploadingModal').modal("show");
      this._auth.uploadToFirebase(file, newfile, 'events/'+this._appData.event.id.toString()+'/'+this.category).subscribe(snapshot =>{
        snapshot.ref.getDownloadURL().then(url => {
          console.log(url);
          let finalURL = url;
          let textures=this.room.textures;
          if (!this.cellSpec){
            textures[newfile]=url;
            this._companyService.updateTextures(this.category,url,this.categories)
          }
          else{
            textures[newfile]={path:url,rows:this.cellSpec[0],cols:this.cellSpec[1]};
            this._companyService.updateTextures(this.category,{path:url,rows:this.cellSpec[0],cols:this.cellSpec[1]},this.categories)

          }
          this.room.textures=textures;
          this._companyService.getRoom(this._appData.object.room).set(this.room).then((val)=>{
            //reload iframe
            var iframe = document.getElementById('gameFrame')
            var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
            iWindow.location.reload();
            $('#uploadingModal').modal('hide');
            $('#editObjectModal').modal('hide');
      })
  
        })
  
      });
    }
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/edit-object-modal/edit-object-component.ts